<template>
  <tsny-modal
    :modal-id="modalId"
    :modal-title="'Update Category'"
    :submit-button-text="'UPDATE'"
    :reset-modal="resetModal"
    :submit-modal="updateCategory"
  >
    <p class="tsny_text">
      Update a question category for this course's exams -- this category and
      its subcategories (if applicable) will be selectable when you create exams
      for this course
    </p>
    <category-form :category="category" />
    <p v-if="updateCategoryError" class="tsny_text">
      Something went wrong updating your category. Go harass your dev
    </p>
  </tsny-modal>
</template>

<script>
import TsnyModal from "../../TsnyModal";
import CategoryForm from "./CategoryForm";
import CourseRestService from "../../../services/rest/services/CourseRestService";

export default {
  name: "UpdateQuestionCategoryModal",
  components: { CategoryForm, TsnyModal },
  props: {
    courseId: {
      type: String,
      default: null
    },
    category: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    modalId: "updateCategoryModal",
    updateCategoryError: false
  }),
  methods: {
    resetModal() {
      this.updateCategoryError = false;
    },
    async updateCategory(bvModalEvt) {
      bvModalEvt.preventDefault();
      let $comp = this;
      $comp.updateCategoryError = false;

      try {
        await CourseRestService.updateCategory(this.courseId, this.category);
        $comp.$bvModal.hide($comp.modalId);
        $comp.$emit("category-updated", this.category);
      } catch (error) {
        $comp.updateCategoryError = true;
        console.log(error);
      }
    }
  }
};
</script>

<style scoped></style>
